import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    ADMIN,
    APPROVED,
    HOSPITAL,
    INDIVIDUAL,
    NURSE,
    WAITING,
} from '@constants/constants';
import {
    adminCreateUser,
    getUserIDInfo,
    getUserInfo,
    getUserName,
    handleFetchLogo,
} from '@utils/utils';
import {
    INDIVIDUAL_USER_PATH,
    HOSPITAL_USER_PATH,
    NURSE_PATH,
    NURSE_USER_PATH,
    HOSPITAL_PATH,
    HOSPITAL_DETAIL_PATH,
} from '@constants/routes';
import { IoMdArrowRoundBack } from 'react-icons/io';
import { useParams, Link } from 'react-router-dom';
import { IoEyeOffOutline, IoEyeOutline } from 'react-icons/io5';
import SharpeInfoIcon from '@components/SvgComponents/SharpInfoIcon';
import { useAppSelector } from '@store/hooks';
import { useAppDispatch } from '@store/hooks';
import {
    setEmail,
    setMobileNumber,
    setName,
    setPassword,
    setUserRole,
} from '@store/reducers/auth/signupSlice';
import { useTranslation } from 'react-i18next';
import HospitalForm from './Form/HospitalForm';
import NurseForm from './Form/NurseForm';
import IndividualForm from './Form/IndividualForm';
import {
    PutItemCommand,
    DynamoDBClient,
    GetItemCommand,
    ScanCommand,
} from '@aws-sdk/client-dynamodb';
import { v4 as uuidv4 } from 'uuid';
import {
    S3Client,
    PutObjectCommand,
    ObjectCannedACL,
    ServerSideEncryption,
    GetObjectCommand,
} from '@aws-sdk/client-s3';
import {
    AdminGetUserCommand,
    CognitoIdentityProviderClient,
} from '@aws-sdk/client-cognito-identity-provider';
import ErrorMessage from '@components/Error/ErrorMessage';

import awsConfig from '../amplifyconfiguration.json';
import { ConsoleLogger } from 'aws-amplify/utils';
import { FaArrowLeftLong } from 'react-icons/fa6';
import {
    checkHospitalList,
    createAdminUser,
    getUserAttributes,
    userInfo,
} from '@utils/authUtils';
import SuccessPopUp from './SuccessPopUpComponent';
import {
    setHospitalDetail,
    setUserDetail,
    setUserDeviceList,
} from '@store/reducers/userSlice';
import UserRole from '../views/pages/auth/UserRole';
import {
    COGNITO_USER_ID,
    TENANT_ID,
    USER_EMAIL,
    USER_MOBILE_NUMBER,
    USER_ROLE,
} from '@constants/cognitoAttributes';
import { setNurseDetail } from '../store/reducers/userSlice';
import { checkDeviceIdExists } from '@utils/deviceUtils';
import { hospitalInfoData, hospitalUserInfo } from '@utils/hospitalUtils';
import { getDataUsingHospitalId, getDataUsingUserId } from '@utils/sharedUtils';
import { HOSPITALS_TABLE } from '@constants/dynamoDBTableName';
import {
    EMAIL_MAX_Length,
    EMAIL_PATTERN,
    EMAIL_TITLE,
    MOBILE_NUMBER_MAX_LENGTH,
    MOBILE_NUMBER_MIN_LENGTH,
    MOBILE_NUMBER_PATTERN,
    MOBILE_NUMBER_TITLE,
    NAME_TEXT_MAX_LENGTH,
    NAME_TEXT_MIN_LENGTH,
    NAME_TEXT_PATTERN,
    NAME_TEXT_TITLE,
    PASSWORD_MAX_Length,
    PASSWORD_MIN_Length,
    PASSWORD_PATTERN,
    PASSWORD_TITLE,
} from '@constants/form';
import { useAuditLog } from '../contexts/AuditLogContext';

interface UserDeviceList {
    id: number;
    device_id: string;
    create_date: string;
}

const CreateAdminUserComponent: React.FC = () => {
    // const [name, setName] = useState('');
    // const [email, setEmail] = useState('');
    // const [mobileNo, setMobileNo] = useState('');
    // const [password, setPassword] = useState('');
    const [errors, setErrors] = useState<{ [key: string]: string }>({});
    const [error, setError] = useState<string | null>(null);
    const [hospitalDetails, setHopsitalDetails] = useState<any>({});
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const dispatch = useAppDispatch();
    const name = useAppSelector((state) => state.signup.name);
    const email = useAppSelector((state) => state.signup.email);
    const mobileNumber = useAppSelector((state) => state.signup.mobileNumber);
    const password = useAppSelector((state) => state.signup.password);
    const [buttonText, setButtonText] = useState('');
    const deviceUniqueID = useAppSelector(
        (state) => state.signup.deviceUniqueID
    );
    const userEmail = useAppSelector((state) => state.signup.email);
    const UserMobileNumber = useAppSelector(
        (state) => state.signup.mobileNumber
    );
    const userPassword = useAppSelector((state) => state.signup.password);
    const userDeviceUniqueID = useAppSelector(
        (state) => state.signup.deviceUniqueID
    );
    const userRole = useAppSelector((state) => state.signup.userRole);
    const userState = useAppSelector((state) => state.signup.userState);
    const userName = useAppSelector((state) => state.signup.name);
    const hospitalName = useAppSelector((state) => state.signup.hospital_name);
    const hospitalBranchName = useAppSelector(
        (state) => state.signup.hospital_branch
    );
    const adminHospitalName = useAppSelector((state) => state.signup.name);
    const hospitalWebsite = useAppSelector(
        (state) => state.signup.hospital_website
    );
    const hospitalEmailID = useAppSelector((state) => state.signup.email_id);
    const hospitalContactNumber = useAppSelector(
        (state) => state.signup.contact_no
    );
    const hospitalGST = useAppSelector((state) => state.signup.gst_no);
    const logo = useAppSelector((state) => state.signup.logo);
    const logo_name = useAppSelector((state) => state.signup.logo_name);
    const logo_url = useAppSelector((state) => state.signup.logo_url);
    const logo_type = useAppSelector((state) => state.signup.logo_type);
    const userAddressOne = useAppSelector((state) => state.signup.address_one);
    const userAddressTwo = useAppSelector((state) => state.signup.address_two);
    const userCity = useAppSelector((state) => state.signup.city);
    const userCountry = useAppSelector((state) => state.signup.country);
    const userPincode = useAppSelector((state) => state.signup.pincode);
    const { t } = useTranslation();
    const tenantUuid = uuidv4();
    const hospitalTenantUuid = uuidv4();
    const hospitalUuid = uuidv4();
    const hospitalInfoUuid = uuidv4();
    const userInfoUuid = uuidv4();
    const [userID, setUserID] = useState('');
    const [slugName, setSlugName] = useState('');
    const [showModal, setShowModal] = useState(false);
    const loggedInUserRole = useAppSelector(
        (state) => state.login.loggedInUserRole
    );
    const loggedInUserTenantID = useAppSelector(
        (state) => state.login.loggedInUserTenantID
    );
    const loggedInUserID = useAppSelector(
        (state) => state.login.loggedInUserID
    );
    const hospitalTelephone = useAppSelector(
        (state) => state.signup.telephoneNumber
    );
    const hospitalTenantId = useAppSelector(
        (state) => state.signup.hospitalTenantId
    );
    const { addLog } = useAuditLog();

    const hospitalUser = useAppSelector((state) => state.signup.hospitalUser);

    async function fetchData() {
        if (loggedInUserRole.toLowerCase() === ADMIN.toLowerCase()) {
            const data = await hospitalInfoData(hospitalTenantId);
            if (data && data.length > 0) {
                setHopsitalDetails(data[0]);
            }
        } else {
            const data = await hospitalInfoData(loggedInUserTenantID);
            if (data && data.length > 0) {
                setHopsitalDetails(data[0]);
            }
        }
        // const data = await hospitalInfoData(loggedInUserTenantID);
        // if (data && data.length > 0) {
        //     setHopsitalDetails(data[0]);
        // }
    }

    useEffect(() => {
        if (!hospitalUser) {
            if (loggedInUserRole.toLowerCase() === ADMIN.toLowerCase()) {
                navigate(HOSPITAL_DETAIL_PATH);
            } else {
                navigate(HOSPITAL_PATH);
            }
        }

        fetchData();
    }, [location.pathname, navigate, hospitalUser]);

    // const validateForm = () => {
    //     const newErrors: { [key: string]: string } = {};
    //     if (!name) newErrors.name = 'Name is required';
    //     if (!email) newErrors.email = 'Email is required';
    //     if (!mobileNo) newErrors.mobileNo = 'Mobile number is required';
    //     // if (!password) newErrors.password = 'Password is required';
    //     else if (password.length < 6)
    //         newErrors.password = 'Password must be at least 6 characters';
    //     return newErrors;
    // };
    // const togglePasswordVisibility = () => {
    //     setShowPassword((prevShowPassword) => !prevShowPassword);
    // };

    function generateSlug(name: string) {
        const firstWord = name.split(' ')[0]; // Take only the first word
        const baseSlug = firstWord
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, '-') // Replace non-alphanumeric characters with hyphens
            .replace(/(^-|-$)+/g, ''); // Remove leading and trailing hyphens
        const uniqueId = uuidv4().split('-')[0]; // Take a part of the UUID to ensure uniqueness
        return `${baseSlug}-${uniqueId}`;
    }



    function validateEmail(email: string) {
        const pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return pattern.test(email);
    }

    const getItemFromDynamoDB = async (key: any) => {
        try {
            const response = await getDataUsingHospitalId(HOSPITALS_TABLE, key);

            if (response && response.Items && response.Items.length > 0) {
                const data = response.Items[0];
                const status = data.status?.S;
                if (data.status?.S?.toLowerCase() == APPROVED.toLowerCase()) {
                    return response.Items;
                } else {
                    return null;
                }
            } else {
                return null;
            }
        } catch (error: any) {
            let errorMessage = 'Unexpected error';

            switch (error.name) {
                case 'ProvisionedThroughputExceededException':
                case 'RequestLimitExceeded':
                    errorMessage = 'Request limit exceeded';
                    break;
                case 'ResourceNotFoundException':
                    errorMessage = 'Resource not found';
                    break;
                case 'ConditionalCheckFailedException':
                    errorMessage = 'Conditional check failed';
                    break;
                case 'InternalServerError':
                    errorMessage = 'Internal server error';
                    break;
                case 'ValidationException':
                    errorMessage = 'Validation exception';
                    break;
                case 'AccessDeniedException':
                    errorMessage = 'Access denied';
                    break;
                default:
                    errorMessage = error.message || 'Unexpected error';
            }

            setError(errorMessage);
            return null;
        }
    };

    const handleSubmit = async (event: React.FormEvent) => {
        event.preventDefault();

        try {
            if (!validateEmail(email)) {
                setError('Invalid email');
                return;
            }

            let user_tenant_id;
            if (loggedInUserRole.toLowerCase() === ADMIN.toLowerCase()) {
                user_tenant_id = hospitalTenantId;
            } else {
                user_tenant_id = loggedInUserTenantID;
            }

            const pathname = location.pathname;

            const userData = [
                {
                    Name: USER_EMAIL,
                    Value: email,
                },
                {
                    Name: USER_MOBILE_NUMBER,
                    Value: mobileNumber,
                },
                {
                    Name: USER_ROLE,
                    Value: HOSPITAL,
                },
                {
                    Name: 'email_verified',
                    Value: 'true',
                },
                {
                    Name: 'custom:tenant_id',
                    Value: user_tenant_id,
                },
                {
                    Name: 'custom:device_id',
                    Value: deviceUniqueID,
                },
            ];

            const res = await adminCreateUser(email, userData, password);
            // const attributes = await getUserAttributes();

            // if (typeof attributes !== 'string' && attributes !== null) {
            const updated_By = loggedInUserTenantID;
            const userId = loggedInUserID;
            if (res.id) {
                setUserID(res.id);
                const userNameOrHospitalName = hospitalName;
                const userSlug = generateSlug(userNameOrHospitalName);
                setSlugName(userSlug);
                const data = {
                    id: tenantUuid,
                    userInfo_uuid: userInfoUuid,
                    logoName: '',
                    role: HOSPITAL,
                    name: userName,
                    userEmail: email,
                    userMobile: mobileNumber,
                    userDeviceId: '',
                    addressOne: hospitalDetails.address1?.S,
                    addressTwo: hospitalDetails.address2?.S,
                    city: hospitalDetails.city?.S,
                    state: hospitalDetails.state?.S,
                    country: hospitalDetails.country?.S,
                    pincode: hospitalDetails.pincode?.S,
                    status: APPROVED,
                    slug: userSlug,
                    userId: res.id,
                    gst: hospitalDetails.gst?.S,
                    hospitalId: hospitalDetails.hospital_id?.S,
                    hospitalName: hospitalDetails.hospital_name?.S,
                    hospitalEmailID: hospitalDetails.hospital_email?.S,
                    hospitalWebsite: hospitalDetails.hospital_website?.S,
                    hospitalContactNumber: hospitalDetails.hospital_contact?.S,
                    hospitalTelephoneNumber: hospitalTelephone,
                    tenant_id: user_tenant_id,
                    approvedBy: userId,
                    updatedBy: userId,
                };
                // console.log('hospital_uuid', hospital_uuid);
                // console.log('hospitalName', hospitalName);
                // console.log('hospitalID', hospitalID);

                // setShowModal(true);
                await createAdminUser(data);
                addLog(
                    'User Created',
                    userInfoUuid,
                    'User',
                    loggedInUserID,
                    { 'User': email, 'Role': data.role },
                    window.location.hostname
                );
                if (loggedInUserRole.toLowerCase() === ADMIN.toLowerCase()) {
                    navigate(HOSPITAL_DETAIL_PATH);
                } else {
                    navigate(HOSPITAL_PATH);
                }
            }
            // }
        } catch (error: any) {
            // setError(error);
            // setError(error.message || String(error));
            let errorMessage;
            switch (error.name) {
                case 'UserNotFoundException':
                    errorMessage = 'User not found.';
                    break;
                case 'UsernameExistsException':
                    errorMessage = 'Email already exists.';
                    break;
                case 'InvalidParameterException':
                    errorMessage = 'Invalid parameters provided.';
                    break;
                case 'LimitExceededException':
                    errorMessage = 'Limit exceeded.';
                    break;
                case 'InternalErrorException':
                    errorMessage = 'Internal server error.';
                    break;
                default:
                    errorMessage =
                        error.message || 'An unknown error occurred.';
            }
            setError(errorMessage);
        }

        // navigate('/users'); // Uncomment this line to navigate after successful user creation
    };

    function getFormattedDate() {
        const date = new Date();
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based, so we add 1
        const year = date.getFullYear();

        return `${day}/${month}/${year}`;
    }

    const backArrow = () => {
        // console.log(pathname);
        // Check if the pathname matches any of the paths from AppConfig
        // if (pathname.startsWith(HOSPITAL_USER_PATH + '/')) {
        //     navigate(HOSPITAL_USER_PATH);
        // } else if (pathname.startsWith(INDIVIDUAL_USER_PATH + '/')) {
        //     navigate(INDIVIDUAL_USER_PATH);
        // } else if (pathname.startsWith(NURSE_PATH + '/')) {
        //     navigate(NURSE_PATH);
        // }
        navigate(-1);
    };

    const handleNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        // dispatch(setName(event.target.value));
        const value = event.target.value;
        const regex = /^[A-Za-z\s]*$/;
        if (regex.test(value)) {
            dispatch(setName(value));
        }
    };

    const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        dispatch(setEmail(event.target.value));
    };

    const handleMobileNumberChange = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        const value = event.target.value;
        // Allow only numbers (0-9)
        if (/^\d*$/.test(value)) {
            dispatch(setMobileNumber(value));
        }
        // dispatch(setMobileNumber(event.target.value));
    };

    const handlePasswordChange = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        dispatch(setPassword(event.target.value));
    };

    const handleTogglePasswordVisibility = () => {
        setShowPassword((prevShowPassword) => !prevShowPassword);
    };

    return (
        <>
            <div className="mx-auto px-5">
                <div className="font-bold text-black text-base">
                    {/* <Link to={HOSPITAL_USER_PATH}> */}
                    <div
                        className="flex items-center cursor-pointer"
                        onClick={backArrow}
                    >
                        <FaArrowLeftLong className="" />{' '}
                        <h2 className="font-semibold ml-2">
                            {t('auth.signup.add_hospital_admin')}
                        </h2>
                    </div>
                    {/* </Link> */}
                </div>
                {error && <ErrorMessage message={error} />}
                <div className="cart relative mx-auto bg-white rounded-2xl p-5 mt-5 w-11/12">
                    <form onSubmit={handleSubmit} className="w-10/12 mx-auto">
                        <div className="flex justify-start mt-3">
                            <div className="w-2/4 mr-8">
                                <label
                                    htmlFor="admin_name"
                                    className="mb-2 text-sm font-medium text-light_grey"
                                >
                                    {t('auth.signup.admin_name_lable')}
                                    <span className="text-red ml-2">*</span>
                                </label>
                                <input
                                    type="text"
                                    name="admin_name"
                                    id="admin_name"
                                    value={name}
                                    onChange={handleNameChange}
                                    className="form-control px-3 py-2 placeholder-gains_boro"
                                    placeholder={t(
                                        'auth.signup.admin_name_placeholder'
                                    )}
                                    minLength={NAME_TEXT_MIN_LENGTH}
                                    maxLength={NAME_TEXT_MAX_LENGTH}
                                    title={NAME_TEXT_TITLE}
                                    pattern={NAME_TEXT_PATTERN}
                                    required
                                />
                            </div>
                            <div className="w-2/4">
                                <label
                                    htmlFor="mobile_number"
                                    className="mb-2 text-sm font-medium text-light_grey"
                                >
                                    {t('auth.signup.mobile_number_label')}
                                    <span className="text-red ml-2">*</span>
                                </label>
                                <input
                                    type="text"
                                    name="mobile_number"
                                    id="mobile_number"
                                    value={mobileNumber}
                                    onChange={handleMobileNumberChange}
                                    className="form-control px-3 py-2 placeholder-gains_boro"
                                    placeholder={t(
                                        'auth.signup.mobile_number_placeholder'
                                    )}
                                    pattern={MOBILE_NUMBER_PATTERN}
                                    title={MOBILE_NUMBER_TITLE}
                                    minLength={MOBILE_NUMBER_MIN_LENGTH}
                                    maxLength={MOBILE_NUMBER_MAX_LENGTH}
                                    required
                                />
                            </div>
                        </div>
                        <div className="flex justify-start mt-4">
                            <div className="w-2/4 mr-8">
                                <label
                                    htmlFor="email"
                                    className="mb-2 text-sm font-medium text-light_grey"
                                >
                                    {t('auth.signup.email_id_label')}
                                    <span className="text-red ml-2">*</span>
                                </label>
                                <input
                                    type="email"
                                    name="email"
                                    id="signup_email"
                                    value={email}
                                    onChange={handleEmailChange}
                                    className="form-control px-3 py-2 placeholder-gains_boro"
                                    placeholder={t(
                                        'auth.signup.email_id_placeholder'
                                    )}
                                    pattern={EMAIL_PATTERN}
                                    title={EMAIL_TITLE}
                                    maxLength={EMAIL_MAX_Length}
                                    required
                                    autoComplete="off"
                                />
                            </div>
                            <div className="w-2/4">
                                <label
                                    htmlFor="password"
                                    className="mb-2 text-sm font-medium text-light_grey"
                                >
                                    {t('auth.signup.password_label')}
                                </label>
                                <div className="relative flex items-center rounded-md">
                                    <input
                                        type={
                                            showPassword ? 'text' : 'password'
                                        }
                                        name="password"
                                        id="signup_password"
                                        value={password}
                                        onChange={handlePasswordChange}
                                        className="form-control px-3 py-2 placeholder-gains_boro"
                                        placeholder={t(
                                            'auth.signup.password_placeholder'
                                        )}
                                        minLength={PASSWORD_MIN_Length}
                                        maxLength={PASSWORD_MAX_Length}
                                        pattern={PASSWORD_PATTERN}
                                        title={PASSWORD_TITLE}
                                        autoComplete="new-password"
                                    />
                                    <button
                                        type="button"
                                        className="absolute right-3 cursor-pointer"
                                        onClick={handleTogglePasswordVisibility}
                                    >
                                        {showPassword ? (
                                            <IoEyeOutline className="text-secondary" />
                                        ) : (
                                            <IoEyeOffOutline className="text-secondary" />
                                        )}
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className="  col-span-2 pb-14 absolute flex -bottom-40 left-1/2 -translate-x-2/4 cursor-pointer justify-center w-full">
                            <button
                                className="bg-primary text-lg text-white py-2  px-4 rounded-lg w-2/6"
                                type="submit"
                            >
                                {t('auth.signup.submit')}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
};

export default CreateAdminUserComponent;
